import { NavigationGuard } from 'vue-router'

import store from '@/store'

/**
 * Checks if the user is logged in.
 */
export const ifAuthenticated: NavigationGuard = (_to, _from, next) => {
  if (store.getters['auth/isAuthenticated']) {
    next()
  } else {
    next('/login')
  }
}

/**
 * Checks if the user is **NOT** logged in.
 */
export const ifNotAuthenticated: NavigationGuard = (_to, _from, next) => {
  if (!store.getters['auth/isAuthenticated']) {
    next()
  } else {
    next('/')
  }
}
